@if (icon) {
    <ce-icon [svgIcon]="icon"></ce-icon>
}
<span class="CePill-content">
    <ng-content></ng-content>

    @if (suffix()) {
        {{ suffix() }}
    }

    @if (removable()) {
        <button type="button" (click)="onRemove($event)" [attr.aria-label]="'Clear selection'" class="CePill-remove">
            <ce-icon svgIcon="close" ce-icon-xs />
        </button>
    }
</span>
